"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

var _typeof = require("@babel/runtime/helpers/typeof");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = exports.TogglerTitle = exports.StyledToggleIcon = void 0;

var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));

var _objectWithoutProperties2 = _interopRequireDefault(require("@babel/runtime/helpers/objectWithoutProperties"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _react = _interopRequireWildcard(require("react"));

var _styledComponents = _interopRequireWildcard(require("styled-components"));

var _Button = _interopRequireDefault(require("../Button"));

var _iconsReact = require("../../icons-react");

var _excluded = ["label", "children"];

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

var AbstractToggler = function AbstractToggler(_ref) {
  var label = _ref.label,
      children = _ref.children,
      rest = (0, _objectWithoutProperties2["default"])(_ref, _excluded);

  var _useState = (0, _react.useState)(false),
      _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
      isOpen = _useState2[0],
      setIsOpen = _useState2[1];

  return /*#__PURE__*/_react["default"].createElement(StyledAbstractToggler, rest, /*#__PURE__*/_react["default"].createElement(TogglerTitle, {
    functional: true,
    onClick: function onClick() {
      return setIsOpen(!isOpen);
    }
  }, label, /*#__PURE__*/_react["default"].createElement(StyledToggleIcon, {
    isOpen: isOpen
  })), isOpen && children);
};

var StyledAbstractToggler = _styledComponents["default"].div.withConfig({
  displayName: "AbstractToggler__StyledAbstractToggler",
  componentId: "sc-ets05k-0"
})([""]);

var TogglerTitle = (0, _styledComponents["default"])(_Button["default"]).withConfig({
  displayName: "AbstractToggler__TogglerTitle",
  componentId: "sc-ets05k-1"
})(["display:flex;align-items:center;"]);
exports.TogglerTitle = TogglerTitle;
var StyledToggleIcon = (0, _styledComponents["default"])(_iconsReact.ArrowDown).withConfig({
  displayName: "AbstractToggler__StyledToggleIcon",
  componentId: "sc-ets05k-2"
})(["margin-left:5px;width:12px;height:6px;path{fill:", ";}", ""], function (props) {
  return props.theme.colors.blackBase;
}, function (props) {
  return !props.isOpen && (0, _styledComponents.css)(["transform:rotate(180deg);"]);
});
exports.StyledToggleIcon = StyledToggleIcon;
AbstractToggler.propTypes = {
  label: _propTypes["default"].node.isRequired,
  children: _propTypes["default"].node.isRequired,
  className: _propTypes["default"].string
};
AbstractToggler.defaultProps = {
  className: ''
};

var _default = /*#__PURE__*/_react["default"].memo(AbstractToggler);

exports["default"] = _default;